// @flow

import {useSearchParams} from 'react-router-dom';

export const useUpsellingQueryParams = (): URLSearchParams => {
  const [searchParams] = useSearchParams();

  for (const key of searchParams.keys()) {
    if (key !== 'upsellingMargin' && key !== 'upsellingTypes') {
      searchParams.delete(key);
    }
  }

  return searchParams;
};
